.signet-dialog {
  .signet-overlay {
    padding: 16px;

    .content {
      display: flex;
      justify-content: center;
      transform: scale(0.95);
      margin-top: -20vh;
      padding-top: 20px;
      box-lines: none;

      .dialog-wrapper {
        width: fit-content;
        max-height: 80vh;
        overflow-y: auto;
        background-color: white;
        padding: 16px;
        transition: all 0.3s ease-in-out;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        margin: 0 !important;

        .dialog-header {
          display: flex;
          justify-content: space-between;
          align-content: flex-start;
          align-items: center;
          margin-bottom: 12px;

          .dialog-title {
            line-height: 1;
            color: var(--text-primary);
          }
        }
      }
    }

    &.opened {
      .content {
        transform: scale(1);

        .dialog-wrapper {
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }
}
